var main = require('integrations/main');

main.baseFiles.footer = require('./components/footer');
main.baseFiles.miniCart = require('./components/miniCart');
main.baseFiles.modalDrawer = require('./components/modalDrawer');
main.baseFiles.readMore = require('./components/readMore');
main.baseFiles.menu = require('./components/menu');
main.baseFiles.back = require('./utilities/back');
main.baseFiles.search = require('./components/search');
main.baseFiles.clientSideValidation = require('./components/clientSideValidation');
main.baseFiles.giftCertificate = require('./giftCertificate/giftCertificate').init;
main.baseFiles.cart = require('./cart');
main.baseFiles.base = require('./product/tile');
main.baseFiles.base = require('./product/base');
main.baseFiles.quickView = require('./product/quickView');
main.baseFiles.slider = require('./components/slider').init;
main.baseFiles.modal = require('./components/modal').init;
main.baseFiles.wishlist = require('./wishlist/wishlist');
main.baseFiles.swatchVeilTrigger = require('./product/swatchVeilTrigger');
main.baseFiles.scrollTo = require('./utilities/scrollTo');
main.baseFiles.confirmation = require('./checkout/confirmation');
main.baseFiles.login = require('./login/login');
main.baseFiles.pageDesigner = require('./pageDesigner');
main.baseFiles.csrf = require('./components/csrf');
main.baseFiles.applePaySessionGuard = require('./components/applePaySessionGuard');

// LEG-559: UncachedData is delivered async now. The vendor desktop header scripts ran at parse
// against the safe stub (-> anonymous no-op); re-hydrate here on data-ready via stable selectors,
// then re-mark wishlist icons (updateLinkData self-guards + defaults to $('[data-wishlistpid]')).
if (window.UncachedDataReady) {
    window.UncachedDataReady.then(function (u) {
        var c = u && u.customer;
        if (c && c.isAuthenticated) {
            var toggle = document.getElementById('dropdownAccountSelector');
            if (toggle) {
                toggle.classList.add('user-authenticated');
                if (c.initial) { toggle.setAttribute('data-account-icon-letter', c.initial); }
                var srLink = toggle.querySelector('a.sr-only');
                if (srLink && c.name) { srLink.textContent = c.name; }
                var dropdown = toggle.closest('.dropdown');
                var container = dropdown && dropdown.querySelector('.dropdown-menu');
                var nav = container && container.querySelector('.nav');
                var menu = window.CachedData && window.CachedData.template && window.CachedData.template.authAccountHeader;
                if (nav && menu) {
                    var swap = function () { nav.innerHTML = menu; };
                    if (container.contains(document.activeElement)) {
                        container.addEventListener('focusout', function onOut() {
                            if (!container.contains(document.activeElement)) { container.removeEventListener('focusout', onOut); swap(); }
                        });
                    } else { swap(); }
                }
            }
        }
        require('core/wishlist/components/helpers').updateLinkData();
    });
}

module.exports = main;
